import { render, staticRenderFns } from "./ExamCompleted.vue?vue&type=template&id=2eebfec8&"
import script from "./ExamCompleted.vue?vue&type=script&lang=js&"
export * from "./ExamCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports